export default function CsharpOutput() {
  return (
    <h2>Csharp Output</h2>
  );
}
